module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDnWnDkYbFIAAAAEHRSTlMAEO8gv6+AQDDfUHDPj2CfAHcyNwAAAMpJREFUeF7t1FsOwjAMRFE7adr0yex/tUgVyBAhVHu+QDk7uNLY8ju6rutyFUO4AYMKbwSAIrSM0yKsAaeUhbPiYSDDEp5WMswwIzhgsEmYJrzaJarg3SQxCxqzcmGm8GGID3xCIzhwndEIDnzHZysZZioXZjZ1fzMTHnhFIzrwDd8k5cJMIcPM4fhmJjzwFY3gwHPCBSMZZioR5hq4Jly0e75ZfOALrkvKhZniCAsOfIJPyo5vFhn4AbfF8T0Cl5LdaXOW/9V1XXcHjLVDWNeEyWYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f53a.png
// module id = 1133
// module chunks = 0